<template lang="pug">
  #initials-view.body: .body-inner
    form(@submit.prevent="validateSelf" novalidate)
      UiFormField(
        v-model="surnameModel"
        v-validate="form.surname.rules"
        v-bind="form.surname.params"
        :error="errors.first(form.surname.params.name)"
      )
      UiFormField(
        v-model="nameModel"
        v-validate="form.name.rules"
        v-bind="form.name.params"
        :error="errors.first(form.name.params.name)"
      )
      UiFormField(
        v-model="patronymicModel"
        v-validate="form.patronymic.rules"
        v-bind="form.patronymic.params"
        :error="errors.first(form.patronymic.params.name)"
      )
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  name: 'Initials',
  // Created -------------------------------------------------------------------
  created () {
    this.SET_CURRENT_VIEW({ vm: this })
  },
  // Data ----------------------------------------------------------------------
  data () {
    return {
      form: {
        name: {
          rules: {
            required: true,
            cyr_alpha: true,
            min: 2
          },
          params: {
            name: 'name',
            type: 'text',
            label: 'Имя'
          }
        },
        surname: {
          rules: {
            required: true,
            cyr_alpha: true,
            min: 2
          },
          params: {
            name: 'surname',
            type: 'text',
            label: 'Фамилия'
          }
        },
        patronymic: {
          rules: {
            required: true,
            cyr_alpha: true,
            min: 2
          },
          params: {
            name: 'patronymic',
            type: 'text',
            label: 'Отчество'
          }
        }
      }
    }
  },
  // Computed ------------------------------------------------------------------
  computed: {
    // Vuex map getters of the User SM
    ...mapGetters('moduleUser', [
      'getUserData'
    ]),
    // Surname model
    surnameModel: {
      get () { return this.getUserData.surname },
      set (v) { this.SET_USER_DATA_FIELD({ f: 'surname', v }) }
    },
    // Name model
    nameModel: {
      get () { return this.getUserData.name },
      set (v) { this.SET_USER_DATA_FIELD({ f: 'name', v }) }
    },
    // Patronymic model
    patronymicModel: {
      get () { return this.getUserData.patronymic },
      set (v) { this.SET_USER_DATA_FIELD({ f: 'patronymic', v }) }
    },
    // Robot message
    robotMessage () {
      const brand = this.$store.state.config.branded
      let m = ['anderida', 'ds', 'scapital'].indexOf(brand) > -1
        ? 'Как я могу обращаться к вам?'
        : brand === 'bbg'
          ? 'Инициализация <span class="dhl">BBG Advisor</span>. Идентификация пользователя...'
          : 'Инициализация <span class="dhl">Conomy Terminal</span>. Идентификация пользователя...'
      if (this.nameModel.length > 2 && this.patronymicModel.length > 2) {
        if (['anderida', 'ds', 'scapital'].indexOf(this.$store.state.config.branded) > -1) {
          m += `<br>Приятно познакомиться, <span class="ahl">${this.nameModel} ${this.patronymicModel}</span>!`
        } else {
          m += ` Пользователь определен. Добро пожаловать, <span class="ahl">${this.nameModel} ${this.patronymicModel}</span>! Запуск алгоритма сбора индивидуального инвестиционного портфеля...`
        }
      }
      return m
    }
  },
  // Methods -------------------------------------------------------------------
  methods: {
    // Vuex map mutations of the User SM
    ...mapMutations('moduleUser', [
      'SET_USER_DATA_FIELD'
    ]),
    // Vuex map mutations of the Wizard SM
    ...mapMutations('moduleWizard', [
      'SET_CURRENT_VIEW'
    ]),
    // Vuex map actions of the Security SM
    ...mapActions('moduleSecurity', [
      'sendMessage'
    ]),
    // Self back validator
    async backSelf () {
      //
    },
    // Self next validator
    async nextSelf () {
      // If all is fine => true, else => false
      const res = await this.$validator.validate()
        .then(result => {
          return result
        })
      if (res) this.sendMessage({ e: 'InitialsComplete' })
      return res
    }
  }
}
</script>
